export default __webpack_public_path__ + "static/icon_revisions.693625b4707583b1cfb8bd5e7d66f46b.png";